export const maintenanceWorkflowsTableColumns = [
  { value: 'protocol_number', label: 'Número de protocolo' },
  { value: 'status', label: 'Status' },
  { value: 'current_forwarding', label: 'Encaminhamento atual' },
  { value: 'equipment', label: 'Equipamento' },
  { value: 'branch', label: 'Filial' },
  { value: 'establishment', label: 'Estabelecimento' },
  { value: 'creator', label: 'Autor' },
  { value: 'observations', label: 'Descrição' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
